window.onload = function () {

  /* show / hide main nav
  -------------------------------------------------- */

  const nav = document.querySelector('.js-nav');
  const btnnav = document.querySelector('.js-toggle-icon');

  if (nav && btnnav) {
    // Toggle menu to visible
    btnnav.addEventListener("click", () => {
      nav.classList.toggle('is-open');
    });

    // Toggle burger and close icon
    btnnav.addEventListener("click", () => {
      // toggleCSSclasses(one, "icon-close");
      btnnav.classList.toggle('icon-close');
      btnnav.classList.toggle('icon-menu');
    });
  }
};

// Handle mobile navigation
document.addEventListener('DOMContentLoaded', () => {
  // Trigger
  let trigger = document.querySelector('.header-navigation-trigger');
  let headerNavigation = document.querySelector('.header-navigation-container');
  let links = document.querySelectorAll('.header-navigation li > a');
  let body = document.querySelector('body');

  if (trigger && headerNavigation) {
    // Handle click event
    trigger.addEventListener('click', () => {
      if (trigger.classList.contains('active')) {
        setTimeout(function () {
        }, 700);
        trigger.classList.remove('active');
        headerNavigation.classList.remove('active');
        body.classList.remove('mobile-navigation-active');
      } else {
        trigger.classList.add('active');
        headerNavigation.classList.add('active');
        body.classList.add('mobile-navigation-active');
      }
    });

    // Handle click for links
    links.forEach(function (item) {
      item.addEventListener('click', () => {
        trigger.classList.remove('active');
        headerNavigation.classList.remove('active');
        body.classList.remove('mobile-navigation-active');
      });
    });

    // Handle click for submenus
    let submenus = document.querySelectorAll('.header-navigation .level_1 > li.submenu');
    submenus.forEach(function (item) {
      let arrow = item.querySelector('.arrow');
      if (arrow) {
        arrow.addEventListener('click', () => {
          // First close all other submenus
          submenus.forEach(function (submenu) {
            if (item !== submenu) {
              submenu.classList.remove('active');
            }
          });

          // Then open the clicked one
          item.classList.toggle('active');
        });
      }
    });

    // Close mobile navigation on resize
    ['resize'].forEach(function (item) {
      window.addEventListener(item, () => {
        trigger.classList.remove('active');
        headerNavigation.classList.remove('active');
        body.classList.remove('mobile-navigation-active');
      });
    });

    // Close on click on active site
    let activeItem = document.querySelector('li strong.active');
    if (activeItem) {
      activeItem.addEventListener('click', function (event) {
        trigger.classList.remove('active');
        headerNavigation.classList.remove('active');
        body.classList.remove('mobile-navigation-active');
      });
    }
  }
});